export default __webpack_public_path__ + "static/code-snippet@2x-25563747dbf7839172b6ad869a5c9522.png";